/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';

const DoubleUndo = () => {
  return (
    <svg className="MuiSvgIcon-root" width="20" height="20" viewBox="0 0 20 20" focusable="false">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.84914 8C7.35614 6.65833 9.31118 5.83333 11.4699 5.83333C15.2577 5.83333 18.4591 8.35833 19.5833 11.85L17.6608 12.5C16.8055 9.84167 14.3617 7.91667 11.4699 7.91667C9.88139 7.91667 8.43141 8.51667 7.29912 9.48333L10.248 12.5H2.91658V5L5.84914 8Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.08325 8.43982L0.833252 7.08325V14.5828H0.833476V14.583L8.33382 14.583L6.97725 13.333L2.08325 13.333V8.43982Z"
      />
    </svg>
  );
};

export default DoubleUndo;
